import {
    Button,
    Container,
    Dropdown,
} from "react-bootstrap";

import "./css/index.css";
import { List } from "../../axios";
import { useEffect, useState } from "react";
import CatalogItem from "../catalogItem";
import { queryStringToObject } from "../../page/cartPage";

export default function Catalog(params) {
    const [list, setList] = useState([]);
    const [listFilter, setListFilter] = useState([]);
    const [load, setLoad] = useState(false);
    const [countRender, setCountRender] = useState(5);
    const [filterVal, setFilterVal] =
        useState("По умолчанию");


    let loc = window.location;

    
    const handleLoadList = async () => {
        const rezult = await List();

        if (rezult.success) {
            setList(rezult.list);
            setListFilter(
                rezult.list.slice(0, countRender)
            );
            setLoad(true);
        } else {
            setLoad(false);
        }
    };

    const handleAddRender = (count) => {
        setCountRender((prevCountRender) => prevCountRender + count);
      };
    let desiredValue = 0;
    function Filters({ value }) {
        let data = list;
        switch (value) {
            case "1 комнатные":
                desiredValue = 1; // Указанное значение для фильтрации

                data.sort((a, b) => {
                    // Если оба элемента равны указанному значению, оставляем их порядок без изменений
                    if (
                        parseFloat(a.rooms) ===
                            desiredValue &&
                        parseFloat(b.rooms) === desiredValue
                    ) {
                        return 0;
                    }
                    // Если элемент a равен указанному значению, он идет первым
                    if (
                        parseFloat(a.rooms) === desiredValue
                    ) {
                        return -1;
                    }
                    // Если элемент b равен указанному значению, он идет первым
                    if (
                        parseFloat(b.rooms) === desiredValue
                    ) {
                        return 1;
                    }
                    // Если ни один из элементов не равен указанному значению, сортируем их по убыванию
                    return (
                        parseFloat(b.rooms) -
                        parseFloat(a.rooms)
                    );
                });
                setListFilter(data.slice(0, countRender));
                setFilterVal("1 комнатные");
                break;
            case "2 комнатные":
                desiredValue = 2; // Указанное значение для фильтрации

                data.sort((a, b) => {
                    // Если оба элемента равны указанному значению, оставляем их порядок без изменений
                    if (
                        parseFloat(a.rooms) ===
                            desiredValue &&
                        parseFloat(b.rooms) === desiredValue
                    ) {
                        return 0;
                    }
                    // Если элемент a равен указанному значению, он идет первым
                    if (
                        parseFloat(a.rooms) === desiredValue
                    ) {
                        return -1;
                    }
                    // Если элемент b равен указанному значению, он идет первым
                    if (
                        parseFloat(b.rooms) === desiredValue
                    ) {
                        return 1;
                    }
                    // Если ни один из элементов не равен указанному значению, сортируем их по убыванию
                    return (
                        parseFloat(b.rooms) -
                        parseFloat(a.rooms)
                    );
                });
                setListFilter(data.slice(0, countRender));
                setFilterVal("2 комнатные");
                break;
            case "3 комнатные":
                desiredValue = 3; // Указанное значение для фильтрации

                data.sort((a, b) => {
                    // Если оба элемента равны указанному значению, оставляем их порядок без изменений
                    if (
                        parseFloat(a.rooms) ===
                            desiredValue &&
                        parseFloat(b.rooms) === desiredValue
                    ) {
                        return 0;
                    }
                    // Если элемент a равен указанному значению, он идет первым
                    if (
                        parseFloat(a.rooms) === desiredValue
                    ) {
                        return -1;
                    }
                    // Если элемент b равен указанному значению, он идет первым
                    if (
                        parseFloat(b.rooms) === desiredValue
                    ) {
                        return 1;
                    }
                    // Если ни один из элементов не равен указанному значению, сортируем их по убыванию
                    return (
                        parseFloat(b.rooms) -
                        parseFloat(a.rooms)
                    );
                });
                setListFilter(data.slice(0, countRender));
                setFilterVal("3 комнатные");
                break;
            case "По умолчанию":
                setListFilter(list.slice(0, countRender));
                break;
            default:
                break;
        }
    }
    useEffect(() => {
        handleLoadList();

        if (loc.search != "") {
            window.localStorage.setItem('utm', JSON.stringify(queryStringToObject(loc.search)));
        }
    }, []);
    useEffect(() => {
        setListFilter(list.slice(0, countRender));
      }, [countRender, list]);
    
    return (
        <section className="catalog ">
            <Container className="container-sm ">
                <h1>Посуточная аренда квартир в Ульяновске</h1>

                <div className="catalog_count flex">
                    <div className="catalog_count_box">
                        <svg
                            width="20"
                            height="20"
                            viewBox="0 0 20 20"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <circle
                                cx="10"
                                cy="10"
                                r="9"
                                fill="white"
                            ></circle>
                            <path
                                fillRule="evenodd"
                                clipRule="evenodd"
                                d="M10.7143 0.714286C10.7143 0.319797 10.3945 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20C15.5228 20 20 15.5228 20 10C20 9.60551 19.6802 9.28571 19.2857 9.28571C18.8912 9.28571 18.5714 9.60551 18.5714 10C18.5714 14.7339 14.7339 18.5714 10 18.5714C5.26613 18.5714 1.42857 14.7339 1.42857 10C1.42857 5.26613 5.26613 1.42857 10 1.42857C10.3945 1.42857 10.7143 1.10877 10.7143 0.714286Z"
                                fill="#02542E"
                            ></path>
                            <path
                                fillRule="evenodd"
                                clipRule="evenodd"
                                d="M18.9368 1.70284C19.2708 1.96531 19.3289 2.44889 19.0664 2.78295L10.6048 13.5522C10.4571 13.7402 10.2304 13.8488 9.99134 13.8461C9.75228 13.8434 9.52805 13.7297 9.3846 13.5385L4.76922 7.38462C4.51432 7.04476 4.5832 6.5626 4.92306 6.3077C5.26293 6.0528 5.74509 6.12168 5.99999 6.46155L10.0142 11.8138L17.8567 1.83245C18.1191 1.4984 18.6027 1.44037 18.9368 1.70284Z"
                                fill="#02542E"
                            ></path>
                        </svg>
                    </div>
                    <span>{list.length} вариантов комфортабельных <br /> квартир различной площади</span>
                    
                </div>
                <div className="catalog_menu flex">
                    <Dropdown>
                        <Dropdown.Toggle
                            variant="success"
                            id="dropdown-basic"
                            className="catalog_menu-drop flex"
                        >
                            {filterVal}
                        </Dropdown.Toggle>

                        <Dropdown.Menu>
                            {filterVal !=
                                "По умолчанию" && (
                                <Dropdown.Item
                                    onClick={() =>
                                        Filters({
                                            value: "По умолчанию",
                                        })
                                    }
                                >
                                    По умолчанию
                                </Dropdown.Item>
                            )}
                            {filterVal != "1 комнатные" && (
                                <Dropdown.Item
                                    onClick={() =>
                                        Filters({
                                            value: "1 комнатные",
                                        })
                                    }
                                >
                                    1 комнатные
                                </Dropdown.Item>
                            )}
                            {filterVal != "2 комнатные" && (
                                <Dropdown.Item
                                    onClick={() =>
                                        Filters({
                                            value: "2 комнатные",
                                        })
                                    }
                                >
                                    2 комнатные
                                </Dropdown.Item>
                            )}
                            {filterVal != "3 комнатные" && (
                                <Dropdown.Item
                                    onClick={() =>
                                        Filters({
                                            value: "3 комнатные",
                                        })
                                    }
                                >
                                    3 комнатные
                                </Dropdown.Item>
                            )}
                        </Dropdown.Menu>
                    </Dropdown>
                </div>

                {load && (
                    <>
                        <div className="catalog_content">
                            {listFilter.map((e, i) => (
                                <CatalogItem
                                    key={e.id}
                                    gallary={e.gallary}
                                    title={e.title}
                                    rooms={e.rooms}
                                    square={e.square}
                                    description={
                                        e.description
                                    }
                                    price={e.price}
                                    id={e.id}
                                    img={e.img}
                                    url={e.url}
                                    hours_1={e.hours_1}
                                    hours_2={e.hours_2}
                                />
                            ))}
                        </div>
                        {countRender < list.length && (
                            <div className="butBoxAdd">
                                <button
                                    className="button"
                                    onClick={() =>
                                        handleAddRender(5)
                                    }
                                >
                                    Показать ещё
                                </button>
                            </div>
                        )}
                    </>
                )}
            </Container>
        </section>
    );
}
